<template>
  <div class="cotainer card-item">
    <div class="title-box">
      <span class="title-text">团队建设</span>
      <span class="btn-action-group">
        <a-button
          type="primary"
          v-if="oldInfos?.id && !isEdit"
          @click="addGains"
          class="btn-action"
          >新增</a-button
        >
        <!-- <a-button
          class="btn-action"
          type="primary"
          v-if="oldInfos?.id "
          @click="showevidence"
        >
          佐证材料</a-button> -->
        <a-button
          @click="importsj()"
          v-if="oldInfos?.id && !isEdit"
          class="btn-action"
          >导入</a-button
        >
        <!-- <a-button class="btn-action" v-if="oldInfos?.id && !isEdit && oldInfos?.auditState!='2'"  danger type="text" @click="batchDelete">
          批量移除</a-button
        > -->
      </span>
    </div>
    <!-- <div class="title-boxs">
    <span class="btn-action-group" v-if="oldInfos?.id && !isEdit">
        <a-button type="primary" @click="addGains" class="btn-action"
          >新增</a-button
        >
        <a-button @click="importsj()" class="btn-action">导入</a-button>
        <a-button class="btn-action" danger type="text" @click="batchDelete">
          批量移除</a-button
        >
      </span>
    </div> -->
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{
          emptyText: oldInfos?.id ? '暂无数据' : '填写基本信息之后才能添加内容',
        }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
      >
        <!-- :scroll="{ y: 290 }"
        :row-selection="rowSelection" -->
        <template slot="status" slot-scope="text, record, index">
          <!-- :defaultVisible="true" -->
          <a-tooltip placement="right" v-if="record.status != '2'">
            <template slot="title">
              <span v-if="record.operation == 'INSERT'">
                <div>新增当前数据</div>
                <div
                  v-for="item in insertDiff(record)"
                  :key="item.key || item.field"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}：{{ item.obj2 }}
                </div>
              </span>
              <span v-if="record.operation == 'UPDATE'">
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  属性名称：原数据<span style="color: #3498db; font-size: 20px"
                    >→</span
                  >新数据
                </div>
                <div
                  v-for="item in diff(
                    record.changeTransContent,
                    record.nowTransContent
                  )"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}:<span>{{ item.obj1 }}</span>
                  <span style="color: #3498db; font-size: 20px">→</span
                  ><span>{{ item.obj2 }}</span>
                </div>
              </span>
              <span v-if="record.operation == 'DELETE'">删除当前数据.</span>
              <span v-if="text == '3'">驳回原因:{{ record.remark }}</span>
            </template>
            <div class="statuswz">
              <img
                src="@/assets/images/newadd.png"
                v-if="record.operation == 'INSERT'"
                title="新增"
              />
              <img
                src="@/assets/images/newedit.png"
                v-if="record.operation == 'UPDATE'"
                title="编辑"
              />
              <img
                src="@/assets/images/newdelete.png"
                v-if="record.operation == 'DELETE'"
                title="删除"
              />
              <!-- <img src="@/assets/images/back.png" v-if="record.operation==''" title="正确" /> -->
              <img
                src="@/assets/images/right.png"
                v-if="record.operation == ''"
                title="正常数据"
              />
              <div class="status-code status-orange" v-if="text == '0'"></div>
              <div class="status-code" v-if="text == '1'"></div>
              <div class="status-code status-red" v-if="text == '3'"></div>
              <div class="status-code status-gray" v-if="text == '4'"></div>
            </div>
          </a-tooltip>
          <div class="statuswz" v-else>
            <img src="@/assets/images/right.png" title="正确" />
          </div>
        </template>
        <template slot="sequenceNumber" slot-scope="text, record, index">
          <!-- 如果不需要分页或分页信息不存在，直接使用 index + 1 -->
          <span v-if="!pagination || !pagination.pageSize">{{
            index + 1
          }}</span>
          <!-- 否则计算全局序号 -->
          <span v-else>{{
            (pagination.current - 1) * pagination.pageSize + index + 1
          }}</span>
        </template>
        <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template>
        <span class="flex flex-around" slot="action" slot-scope="record">
          <!-- style="margin: 0 50px" -->
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
            v-if="
              oldInfos?.id &&
              !isEdit &&
              record?.operation != 'DELETE' &&
              record.status != '1' &&
              record.status != '3'
            "
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && !isEdit && record?.operation"
            @click="cancelInfo(record)"
          >
            <img class="img-box" src="@/assets/images/cx.png" alt="" />
            <span>撤销</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
            v-if="oldInfos?.id && !isEdit && !record?.operation"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && isEdit"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要移除待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '4'">您确定要移除已撤销的这条数据吗?</p>
      <p v-else>您确定要移除该条团队建设的数据吗?</p>
    </a-modal>
    <a-modal
      title="您确定撤销吗"
      :visible="showCancelModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOks"
      @cancel="showCancelModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要撤销待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '3'">您确定要撤销已驳回的这条数据吗?</p>
      <p v-else>您确定要撤销当前提交的数据吗?</p>
    </a-modal>
    <!-- 添加团队建设 -->
    <AddTeamBuild ref="addGain" @addGain="addGain"></AddTeamBuild>
    <data-import ref="dataImport" @refreshData="addGain"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :dataid="sj.id"
          :id="id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>
    
<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import AddTeamBuild from "./addTeamBuild.vue";
import evidencelist from "@/components/common/evidencelist";
import { FIELD_LABELS } from "@/components/auditPage/data.js";
import mixin from "@/utils/mixin";
import changeStatusMixin from '@/utils/changeStatusMixin';
import studioListValidate from "./studioListValidate";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "名称",
    dataIndex: "buildName",
    id: "buildName",
    align: "center",
    width: 180,
  },
  {
    title: "年份",
    dataIndex: "acquireYear",
    id: "acquireYear",
    align: "center",
    width: 100,
  },
  {
    title: "数量",
    dataIndex: "amount",
    id: "amount",
    align: "center",
    width: 100,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 164,
    scopedSlots: { customRender: "action" },
  },
];

export default {
  mixins: [changeStatusMixin, mixin, studioListValidate("请添加团队建设")],
  data() {
    return {
      isStudioModule: false, // 是否负责工作室模块
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
      showtable: false,
      id: "",
      title: "",
      sj: {},
      isstatus: false,
      showCancelModel: false,
      fieldLabels: FIELD_LABELS[1]["GZSTUANDUIJIANSHE"],
    };
  },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null && newValue != undefined && newValue) {
          if (
            this.$route.query.new == "preview" ||
            this.$parent?.news == "preview" ||
            (this.$parent.editInfo &&
              this.$parent.editInfo?.type == "preview") ||
            this.oldInfos?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.ensureStatusColumn(columns);
          this.addGain();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
      immediate: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        if (
          this.$route.query.new == "preview" ||
          this.$parent?.news == "preview" ||
          this.$parent?.editInfo?.type == "preview" ||
          this.oldInfos?.type == "preview"
        ) {
          this.isEdit = true;
          return;
        }
        this.isEdit = newValue;
        // 教师角色下， 非负责模块不可编辑
        if (this.$store.state.role == "teacher-role" && !this.isStudioModule) {
          this.isEdit = true;
        }
      },
      immediate: true,
    },
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
  },
  components: {
    AddTeamBuild,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  mounted() {
    const brandModules = this.$store.state.user.studioModules || ""; // 教师负责模块
    // 是否属于负责模块
    this.isStudioModule = brandModules.includes("团队建设");
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    // this.getData();
  },
  methods: {
    cancelInfo(record) {
      this.showCancelModel = true;
      this.sj = record;
    },
    // 新增：处理操作后的数据刷新逻辑
    handleDataAfterOperation(currentPage, totalBefore) {
      // 计算删除后的总数据条数
      const totalAfter = totalBefore - 1;

      if (this.isstatus) {
        // 如果是状态模式，直接刷新数据
        this.getData();
      } else {
        // 计算删除后应该显示的页码
        const pageSize = this.pagination.pageSize;
        const totalPages = Math.ceil(totalAfter / pageSize);

        // 如果当前页没有数据了，且不是第一页，则显示上一页
        if (totalAfter > 0 && currentPage > totalPages) {
          this.pagination.current = Math.max(1, totalPages);
        } else {
          // 否则保持在当前页
          this.pagination.current = currentPage;
        }

        // 刷新数据
        this.getData();
      }
    },
    handleOks() {
      const currentPage = this.pagination.current;
      const totalBeforeCancel = this.pagination.total;
      let data = {
        ids: this.sj.taskId,
      };
      const req =
        this.sj?.status == "1" || this.sj?.status == "3"
          ? postAction(
              "/audit/lxAuditTask/cancelTask?ids=" + this.sj.taskId,
              data
            )
          : deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
              id: this.sj.taskId,
            });
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success("撤销审核成功");
          this.showCancelModel = false;
          this.handleDataAfterOperation(currentPage, totalBeforeCancel);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    seeInfo(row) {
      this.$refs.addGain.init("see", row);
    },
    showevidence(record) {
      this.title = "团队建设";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init("team", this.oldInfos, "团队建设");
    },
    handleOk() {
      const currentPage = this.pagination.current;
      const pageSize = this.pagination.pageSize;
      const totalBeforeDelete = this.pagination.total;
      if (
        this.sj?.status == "1" ||
        this.sj?.status == "4" ||
        this.sj?.status == "0" ||
        this.sj?.status == "3" ||
        (this.sj?.status == "2" && this.sj?.operation)
      ) {
        deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
          id: this.sj.taskId,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.handleDataAfterOperation(currentPage, totalBeforeDelete);
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        deleteAction("/lx/lxTeamBuilding/delete", {
          id: this.deteleId,
          applyId: this.oldInfos?.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.handleDataAfterOperation(currentPage, totalBeforeDelete);
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    addGains() {
      this.$refs.addGain.init("add", this.oldInfos);
    },
    addGain() {
      if (!this.isstatus) {
        this.pagination.current = 1;
      }
      this.getData();
    },
    getData() {
      this.loading = true;

      // 确保页码不小于1
      if (this.pagination.current < 1) {
        this.pagination.current = 1;
      }
      if (this.isstatus && this.oldInfos?.id) {
        let data = {
          applyType: 1,
          // pageNo: this.pagination.current,
          // pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lx/lxTeamBuilding/allList", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              console.log(this.dataList, "444444");
              // this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        let data = {
          applyType: 1,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lx/lxTeamBuilding/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;

              // 如果当前页没有数据，且不是第一页，则自动跳转到上一页
              if (data.length === 0 && this.pagination.current > 1) {
                this.pagination.current -= 1;
                this.getData(); // 重新获取上一页数据
                return;
              }
            }
          }
          this.loading = false;
        });
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.sj = row;
      this.deteleId = row.id;
    },
    editInfo(row) {
      // console.log("row", row);
      this.$refs.addGain.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的团队建设");
      } else {
        const currentPage = this.pagination.current;
        const totalBeforeDelete = this.pagination.total;

        let params = {
          ids: this.selectedRowKeys.toString(),
          applyId: this.oldInfos?.id,
        };
        deleteAction("/lx/lxTeamBuilding/deleteBatch", params).then((res) => {
          if (res.code == 200) {
            this.$message.success("批量移除成功");
            // this.pagination.current = 1;
            // this.getData();
            this.selectedRowKeys = [];
            // 处理批量删除后的页面逻辑
            const deleteCount = this.selectedRowKeys.length;
            const totalAfter = totalBeforeDelete - deleteCount;
            const pageSize = this.pagination.pageSize;
            const totalPages = Math.ceil(totalAfter / pageSize);

            // 如果当前页没有数据了，且不是第一页，则显示上一页
            if (totalAfter > 0 && currentPage > totalPages) {
              this.pagination.current = Math.max(1, totalPages);
            } else {
              // 否则保持在当前页
              this.pagination.current = currentPage;
            }

            this.getData();
            this.$forceUpdate();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>
    
<style scoped="scoped" lang="scss">
.statuswz {
  width: 100%;
  height: 54px;
  line-height: 54px;
  cursor: pointer;

  img {
    width: 20px;
    height: auto;
    margin: 0px auto;
  }

  .status-code {
    width: 40px;
    height: 40px;
    background: url("~@/assets/images/green-sj.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
  .status-red {
    background: url("~@/assets/images/red-sj.png") no-repeat;
    background-size: 100% 100%;
  }
  .status-gray {
    background: url("~@/assets/images/hscx.png") no-repeat;
    background-size: 100% 100%;
  }
  .status-orange {
    background: url("~@/assets/images/dtj.png") no-repeat;
    background-size: 100% 100%;
  }
}
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 20px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 18px;
        font-weight: bold;
        height: 36px;
        line-height: 36px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
    .title-boxs {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 12px;
      font-size: 18px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
<style>
.ant-tooltip {
  max-width: 650px;
}
.ant-tooltip-arrow:before {
  background-color: #fff !important;
  width: 10px;
  height: 10px;
}

.ant-tooltip-inner {
  background-color: #fff !important;
  color: #3e3e3e !important;
  box-shadow: 0 0 12px 0 rgba(1, 39, 78, 0.27);
}
</style>